'use client'

import { useEffect, useState } from 'react'
import { pretendard, pxToRem } from '@ui/style/muiTheme'
import Box from '@mui/joy/Box'
import { Comments } from '@components/common/Comments'
import CommentDrawer from './CommentDrawer'
import { useIsCommentDrawControl } from '@store/isCommentDraw'
import color from '@ui/style/color.theme'
import { useDarkModeControl } from '@hooks/useDarkModeControl'

export interface CommentBoxProps {
	contentId?: string
	contentDiv: string
	drawerLgWidth?: number
	drawerXlWidth?: number
}
const CommentBox = ({ contentId, contentDiv, drawerLgWidth, drawerXlWidth }: CommentBoxProps) => {
	const { isCommentDraw, setIsCommentDraw } = useIsCommentDrawControl()
	const [open, setOpen] = useState<boolean>(false)
	const { darkMode } = useDarkModeControl()
	const handleDrawerOpen = () => {
		setOpen(true)
		setIsCommentDraw(true)
	}
	const handleDrawerClose = () => {
		setOpen(false)
		setIsCommentDraw(false)
	}
	useEffect(() => {
		setOpen(isCommentDraw)
	}, [isCommentDraw])
	useEffect(() => {
		window.addEventListener('openLayer', handleDrawerOpen)
		return () => {
			window.removeEventListener('openLayer', handleDrawerOpen)
			handleDrawerClose()
		}
	}, [])
	return (
		<Box
			className="print-hide"
			sx={{
				'#jtbcmodule-comment-container': {
					'.MuiButton-variantSolid': {
						marginTop: pxToRem(24),
						mx: 'auto',
						display: 'flex',
						height: pxToRem(54),
						background: 'transparent',
						padding: `${pxToRem(18)} ${pxToRem(48)}`,
						borderRadius: '8px',
						border: `1px solid ${darkMode ? '#444' : color.colGray3}`,
						fontFamily: pretendard.style.fontFamily,
						fontSize: pxToRem(16),
						lineHeight: pxToRem(18),
						color: darkMode ? color.colWhite : color.colBlack,
						fontWeight: 600,
						'&:hover, &:active': {
							background: darkMode ? '#444' : color.colGray1,
						},
						'.MuiTypography-root': {
							color: darkMode ? '#777' : color.colGray5,
							fontWeight: 500,
							marginLeft: pxToRem(4),
						},
					},
				},
			}}
		>
			<Comments contentDiv={contentDiv} contentId={contentId} contentSize="3" />
			<CommentDrawer
				contentDiv={contentDiv}
				contentId={contentId}
				open={open}
				onCloseFunction={handleDrawerClose}
				lgWidth={drawerLgWidth}
				xlWidth={drawerXlWidth}
			/>
		</Box>
	)
}

export default CommentBox
